export enum LoginState {
    LOGGED_IN,
    LOGGED_OUT,
    PASSWORD_CHANGE_REQUIRED,
    TWO_FACTOR_AUTHENTICATION_ENFORCED,
}
